import { Component, OnInit } from '@angular/core';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Producao } from '../../../../types/producao.type';

@Component({
  selector: 'app-producaos',
  templateUrl: './producaos.component.html',
  styleUrl: './producaos.component.css'
})
export class ProducaosComponent implements OnInit {

  producaos!: Producao[];
  loading: boolean = true;

  constructor(private integradorService: IntegradorService, private toastService: ToastService) { }

  ngOnInit() {
    this.getProducaos();
  }

  getProducaos() {
    this.loading = true

    this.integradorService.getProducaos().subscribe({
      next: (data) => {
        this.producaos = data;
      },
      error: (error) => {
        this.toastService.erro(error.error.title, "Erro ao buscar: " + error.error.detail)
      },
      complete: () => {
        this.loading = false;
      }
    })
  }


}
